// ============================================================
// ByOurConsent.com -- Privacy Policy
// /privacy
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
    <div style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: '11px', fontFamily: 'sans-serif', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8b6a3a', marginBottom: '8px' }}>
            {title}
        </div>
        <div style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.75 }}>
            {children}
        </div>
    </div>
);

const PrivacyPage = () => (
    <>
        <Helmet><title>Privacy Policy — By Our Consent</title></Helmet>
        <Nav />

        <div style={{ background: '#1e2a3a', borderBottom: '2px solid #8b1a1a', padding: '2rem 1.5rem' }}>
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                <h1 style={{ fontSize: '34px', fontWeight: 600, color: '#e8dfc8', fontFamily: "'EB Garamond', Georgia, serif" }}>Privacy policy</h1>
                <p style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#8a9aaa', marginTop: '6px' }}>Last updated: June 2026</p>
            </div>
        </div>

        <div style={{ maxWidth: '700px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

            <Section title="Overview">
                By Our Consent ("we," "us," or "our") is committed to protecting your privacy.
                This policy explains what information we collect, how we use it, and your rights
                regarding your personal data.
            </Section>

            <Section title="Information we collect">
                <strong style={{ color: '#1e2a3a' }}>Account information:</strong> When you register,
                we collect your name, email address, and password (stored encrypted). You may
                optionally provide a bio, organization, and profile photo.
                <br /><br />
                <strong style={{ color: '#1e2a3a' }}>Purchase information:</strong> When you place an order,
                we collect your shipping address and payment details. Payment processing is handled
                by Stripe — we do not store your card information.
                <br /><br />
                <strong style={{ color: '#1e2a3a' }}>Usage information:</strong> We collect basic analytics
                such as which articles are read and how members engage with the platform. We do not
                use third-party advertising trackers.
            </Section>

            <Section title="How we use your information">
                <ul style={{ margin: '0 0 0 1.25rem', padding: 0, lineHeight: 1.9 }}>
                    <li>To operate and maintain your account</li>
                    <li>To process and fulfill orders</li>
                    <li>To send transactional emails (order confirmations, password resets)</li>
                    <li>To send newsletters if you have opted in (you may unsubscribe at any time)</li>
                    <li>To improve the platform and content</li>
                </ul>
            </Section>

            <Section title="We do not">
                <ul style={{ margin: '0 0 0 1.25rem', padding: 0, lineHeight: 1.9 }}>
                    <li>Sell your personal information to third parties</li>
                    <li>Use your data for advertising or tracking purposes</li>
                    <li>Share your information except as required to fulfill orders (e.g., shipping address to Printful)</li>
                </ul>
            </Section>

            <Section title="Third-party services">
                We use the following trusted third-party services:
                <ul style={{ margin: '8px 0 0 1.25rem', padding: 0, lineHeight: 1.9 }}>
                    <li><strong style={{ color: '#1e2a3a' }}>Stripe</strong> — payment processing</li>
                    <li><strong style={{ color: '#1e2a3a' }}>Printful</strong> — order fulfillment and shipping</li>
                    <li><strong style={{ color: '#1e2a3a' }}>SendGrid</strong> — transactional email delivery</li>
                </ul>
                Each service has its own privacy policy governing how they handle data.
            </Section>

            <Section title="Cookies">
                We use a session token stored in your browser's local storage to keep you
                logged in. We do not use advertising cookies or third-party tracking cookies.
            </Section>

            <Section title="Your rights">
                You may request to access, correct, or delete your personal data at any time
                by contacting us at{' '}
                <a href="mailto:info@byourconsent.com" style={{ color: '#8b1a1a' }}>info@byourconsent.com</a>.
                You may also delete your account from your account settings page.
            </Section>

            <Section title="Data retention">
                We retain your account data for as long as your account is active. Order records
                are retained for 7 years as required by law. You may request deletion of your
                account and personal data at any time.
            </Section>

            <Section title="Contact">
                Questions about this policy? Contact us at{' '}
                <a href="mailto:info@byourconsent.com" style={{ color: '#8b1a1a' }}>info@byourconsent.com</a>
                {' '}or visit our <Link to="/contact" style={{ color: '#8b1a1a' }}>contact page</Link>.
            </Section>

        </div>
        <Footer />
    </>
);

export default PrivacyPage;
